import { Injectable } from '@angular/core';
import FileUpload from '../../../types/media/FileUpload';
import Media from '../../../types/media/Media';
import MediaPreviewDTO from '../../../types/media/MediaPreviewDTO';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class MediaService {
    private readonly content_media_upload_path = 'media/fileupload';
    private readonly context_media_path = 'media';

    constructor(private baseService: BaseService) {
    }

    public async getMedia(id: number): Promise<Media> {
        let path = `/${ id }`;
        return await this.baseService.get<Media>(this.context_media_path + path);
    }

    public async initUpload(fileUpload: FileUpload): Promise<FileUpload> {
        const path = '/init';
        return await this.baseService.post<FileUpload>(this.content_media_upload_path + path, fileUpload);
    }

    public async uploadPart(uploadId: string, part: number, file: Blob): Promise<void> {
        const path = `/part/${ uploadId }/${ part }`;
        const formData = new FormData();
        formData.append('file', file);

        await this.baseService.uploadFile(this.content_media_upload_path + path, formData);
    }

    public async completeUpload(uploadId: string, mediaId?: string): Promise<number> {
        let path = `/complete/${ uploadId }`;
        if (mediaId) {
            path += `?mediaId=${ mediaId }`;
        }
        return await this.baseService.post<number>(this.content_media_upload_path + path, {});
    }

    public async cancelUpload(uploadId: string): Promise<void> {
        const path = `/cancel/${ uploadId }`;
        await this.baseService.get<void>(this.content_media_upload_path + path);
    }

    public async getPaginatedMedia(page: number, pageSize: number, searchKey?: string, sortKey?: string,
                                   sortDirection?: string): Promise<any> {
        let path = `?page=${ page }&size=${ pageSize }`;

        if (searchKey) {
            path += `&filename=${ encodeURIComponent(searchKey) }`;
        }

        if (sortKey) {
            path += `&sortField=${ sortKey }`;
        }

        if (sortDirection) {
            path += `&sortDirection=${ sortDirection }`;
        }

        return await this.baseService.get<any>(this.context_media_path + path);
    }

    public async getAllMediaPreviews(): Promise<MediaPreviewDTO[]> {
        return this.baseService.get<MediaPreviewDTO[]>(this.context_media_path + '/previews');
    }

    public async updateMedia(id: number, updatedMedia: Media): Promise<Media> {
        let path = `/${ id }`;
        return this.baseService.put<Media>(this.context_media_path + path, updatedMedia);
    }

    public async deleteMedia(id: number): Promise<any> {
        let path = `/${ id }`;
        await this.baseService.delete<any>(this.context_media_path + path);
    }

}
